import { LINKS } from '../constants';
import { isCSR } from './env';
export const getLocaleBasePath = (locale) => {
    var _a;
    const UNIFIED_DOMAINS = {
        fr: 'fr-fr',
        de: 'de-de',
        at: 'de-at',
        es: 'es-es',
        nl: 'nl-nl',
        gb: 'en-gb',
        ie: 'en-ie',
    };
    const normalizedLocale = locale.toLowerCase();
    for (const [key, value] of Object.entries(UNIFIED_DOMAINS)) {
        if (normalizedLocale.includes(key)) {
            if (typeof window !== 'undefined' && ((_a = window.location.hostname) === null || _a === void 0 ? void 0 : _a.includes('.com'))) {
                return value;
            }
        }
    }
    switch (normalizedLocale.toLowerCase()) {
        case 'pl-pl':
            return 'pl-pl';
        case 'fi-fi':
            return 'fi-fi';
        case 'en':
        case 'en-us':
            return 'en';
        default:
            return '';
    }
};
export const getRoutePathWithLocalePrefix = ({ path, fallbackLocale = 'de-de', }) => {
    const locale = isCSR() ? document.documentElement.lang : fallbackLocale;
    const localeBasePath = getLocaleBasePath(locale);
    const routePath = path.startsWith('/') ? path : `/${path}`;
    return localeBasePath !== '' ? `/${localeBasePath}${routePath}` : routePath;
};
export const goTo = (path) => {
    var _a;
    const relativePath = getRoutePathWithLocalePrefix({ path });
    (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.assign(relativePath);
};
export const goToLoginPage = () => {
    if (!isCSR())
        return;
    goTo(LINKS.LOGIN);
};
//# sourceMappingURL=navigation.js.map